/**
 * Every cache key in one place.
 *
 * Invalidation is where stale-data bugs live; keeping the keys together makes
 * "what else does this write affect?" a question you can answer by reading one
 * file.
 */
export const queryKeys = {
  houses: {
    all: ['houses'] as const,
    detail: (houseId: string) => ['houses', houseId] as const,
    beds: (houseId: string, roomId: string) =>
      ['houses', houseId, 'rooms', roomId, 'beds'] as const,
  },
  admin: {
    users: ['admin', 'users'] as const,
    households: ['admin', 'households'] as const,
  },
  rooms: {
    all: ['rooms'] as const,
  },
  beds: {
    all: ['beds'] as const,
  },
  guests: {
    all: ['guests'] as const,
    detail: (guestId: string) => ['guests', guestId] as const,
  },
  sojourns: {
    all: ['sojourns'] as const,
    detail: (sojournId: string) => ['sojourns', sojournId] as const,
    locks: (sojournId: string) => ['sojourns', sojournId, 'locks'] as const,
    plan: (sojournId: string) => ['sojourns', sojournId, 'plan'] as const,
  },
} as const;
